/* BiBiJoon theme 10: motion (GSAP + ScrollTrigger + Lenis, all optional), bag drawer,
   AJAX add to bag, product options, bag page, collection/journal/article helpers.
   Every feature degrades to plain Shopify behaviour if a library or the network fails. */
(function () {
  'use strict';
  var CFG = window.BJ10 || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasGsap = !!(window.gsap && window.ScrollTrigger);
  var motion = hasGsap && !reduce;
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------- money */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || 'Rs.{{amount}}';
    var n = (cents / 100);
    function withDelims(num, dec, th, dc) { var p = num.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dc); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withDelims(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelims(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(n, 0, '.', ',');
      return withDelims(n, 2, ',', '.');
    });
  }

  /* ---------------------------------------------------------------- text split helpers */
  function splitLines(el) {
    if (!el || el.getAttribute('data-split-done')) return [];
    el.setAttribute('data-split-done', '');
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="w-wrap"><span class="w">' + w + '</span></span>'; }).join(' ');
    var lines = [], top = null, cur;
    $$('.w-wrap', el).forEach(function (w) {
      if (w.offsetTop !== top) { top = w.offsetTop; cur = []; lines.push(cur); }
      cur.push(w.firstChild.textContent);
    });
    el.innerHTML = lines.map(function (l) { return '<span class="line"><span>' + l.join(' ') + '</span></span>'; }).join('');
    return $$('.line > span', el);
  }
  function splitWords(el) {
    el.innerHTML = el.textContent.trim().split(/\s+/).map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' ');
    return $$('.w', el);
  }

  /* ---------------------------------------------------------------- smooth scroll */
  var lenis = null;
  if (motion && window.Lenis && fine) {
    lenis = new Lenis({ lerp: 0.1 });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }
  function lockScroll(on) {
    if (lenis) { if (on) lenis.stop(); else lenis.start(); }
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  /* ---------------------------------------------------------------- header */
  var hdr = $('[data-hdr]'), hero = $('[data-hero]'), lastY = 0;
  function onScroll(y) {
    if (!hdr || document.body.classList.contains('menu-open')) return;
    hdr.classList.toggle('is-hidden', y > lastY && y > 160);
    hdr.classList.toggle('is-over-hero', !!hero && y < window.innerHeight - 80);
    hdr.classList.toggle('is-scrolled', y > 40);
    lastY = y;
  }
  onScroll(window.scrollY);
  if (lenis) lenis.on('scroll', function (e) { onScroll(e.scroll); });
  else window.addEventListener('scroll', function () { onScroll(window.scrollY); }, { passive: true });

  /* ---------------------------------------------------------------- menu */
  var menuBtn = $('[data-menu-btn]'), menu = $('[data-menu]');
  function setMenu(open) {
    document.body.classList.toggle('menu-open', open);
    if (menu) menu.setAttribute('aria-hidden', String(!open));
    if (menuBtn) menuBtn.setAttribute('aria-expanded', String(open));
    lockScroll(open);
    if (open && motion) gsap.fromTo('.menu .pill, .menu__search, .menu__links > *', { y: 50, opacity: 0 }, { y: 0, opacity: 1, stagger: .03, duration: .7, ease: 'expo.out', delay: .12 });
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(!document.body.classList.contains('menu-open')); });

  /* ---------------------------------------------------------------- bag drawer */
  var bag = $('[data-bag]');
  function setCount(n) {
    $$('[data-bag-count]').forEach(function (el) { el.textContent = n; });
    var t = $('[data-bag-count-text]'); if (t) t.textContent = n + (n === 1 ? ' item' : ' items');
    var b = $('[data-bag-open]'); if (b) b.setAttribute('aria-label', 'Bag, ' + n + ' items');
  }
  function renderBag(cart) {
    if (!bag) return;
    setCount(cart.item_count);
    bag.setAttribute('data-state', cart.item_count ? 'full' : 'empty');
    var free = +bag.getAttribute('data-free') || 0, left = Math.max(0, free - cart.total_price);
    var st = $('[data-bag-ship-text]', bag), bar = $('[data-bag-ship-bar]', bag);
    if (st) st.textContent = free ? (left > 0 ? "You're " + formatMoney(left) + ' away from free delivery.' : "You've unlocked free delivery.") : '';
    if (bar) bar.style.width = free ? Math.min(100, cart.total_price / free * 100) + '%' : '100%';
    $('[data-bag-subtotal]', bag).textContent = formatMoney(cart.total_price);
    $('[data-bag-items]', bag).innerHTML = cart.items.map(function (it, i) {
      var name = (it.product_title || '').split(' – ')[0].split(' (')[0];
      var img = it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : '';
      return '<li class="bag__item" data-key="' + it.key + '">' +
        '<a href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" width="76" height="90">' : '') + '</a>' +
        '<div><a class="bag__item-name" href="' + it.url + '">' + name + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="bag__item-var">' + it.variant_title + '</p>' : '') +
        '<p class="bag__item-price">' + (it.original_line_price !== it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') + formatMoney(it.final_line_price) + '</p>' +
        '<div class="bag__qty"><button type="button" data-bag-step="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-bag-step="1" aria-label="Increase">+</button></div></div>' +
        '<button class="bag__remove" type="button" data-bag-remove>Remove</button></li>';
    }).join('');
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openBag() {
    if (!bag) return false;
    setMenu(false);
    bag.classList.add('is-open'); bag.setAttribute('aria-hidden', 'false'); lockScroll(true);
    var c = $('.bag__close', bag); if (c) setTimeout(function () { c.focus(); }, 300);
    if (motion) gsap.fromTo($$('.bag__item, .bag__empty > *, .bag__ship', bag), { x: 40, opacity: 0 }, { x: 0, opacity: 1, stagger: .05, duration: .7, ease: 'expo.out', delay: .2 });
    return true;
  }
  function closeBag() { if (!bag) return; bag.classList.remove('is-open'); bag.setAttribute('aria-hidden', 'true'); lockScroll(false); }
  function changeLine(key, qty) {
    var li = bag && $('.bag__item[data-key="' + key + '"]', bag); if (li) li.classList.add('is-busy');
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderBag(cart); return cart; });
  }
  if (bag) {
    bag.addEventListener('click', function (e) {
      if (e.target.closest('[data-bag-close]')) { closeBag(); return; }
      var li = e.target.closest('.bag__item'); if (!li) return;
      var q = +$('.bag__qty span', li).textContent;
      if (e.target.closest('[data-bag-step]')) changeLine(li.getAttribute('data-key'), Math.max(0, q + +e.target.closest('[data-bag-step]').getAttribute('data-bag-step')));
      if (e.target.closest('[data-bag-remove]')) changeLine(li.getAttribute('data-key'), 0);
    });
    getCart().then(renderBag).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-bag-open]');
    if (o && bag && !document.body.classList.contains('template-cart')) { e.preventDefault(); openBag(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (bag && bag.classList.contains('is-open')) closeBag();
    else if (document.body.classList.contains('menu-open')) setMenu(false);
  });

  /* dot flies from the button to the bag */
  function flyDot(from, color) {
    var target = $('[data-bag-open]');
    if (!motion || !from || !target) return Promise.resolve();
    if (hdr) hdr.classList.remove('is-hidden');
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    var dot = document.createElement('span'); dot.className = 'fly-dot'; dot.style.background = color || 'var(--c-brighten)';
    dot.style.left = (a.left + a.width / 2 - 9) + 'px'; dot.style.top = (a.top + a.height / 2 - 9) + 'px';
    document.body.appendChild(dot);
    return new Promise(function (res) {
      gsap.timeline({ onComplete: function () { dot.remove(); gsap.fromTo(target, { scale: 1 }, { scale: 1.2, duration: .18, yoyo: true, repeat: 1 }); res(); } })
        .to(dot, { x: b.left + b.width / 2 - (a.left + a.width / 2), duration: .8, ease: 'power1.inOut' }, 0)
        .to(dot, { y: b.top + b.height / 2 - (a.top + a.height / 2), duration: .8, ease: 'back.in(1.6)' }, 0)
        .to(dot, { scale: .5, duration: .8 }, 0);
    });
  }

  /* AJAX add for quick-add forms and the product form. Falls back to a normal
     form submit (Shopify's /cart/add redirect) if the request fails. */
  function addToBag(form, btn) {
    var fd = new FormData(form);
    var color = getComputedStyle(form.closest('[style*="--dot"]') || document.documentElement).getPropertyValue('--dot').trim();
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return flyDot(btn, color); })
      .then(getCart)
      .then(function (cart) { renderBag(cart); openBag(); return true; });
  }
  function showError(btn, err) {
    var msg = (err && (err.description || err.message)) || 'Could not add to bag.';
    var p = document.createElement('p'); p.className = 'bag__note'; p.setAttribute('role', 'alert'); p.textContent = msg;
    var host = btn.closest('form') || btn.parentNode; host.appendChild(p); setTimeout(function () { p.remove(); }, 4000);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-bj10-add]')) {
      e.preventDefault();
      var btn = $('.card__add', form); btn.disabled = true;
      addToBag(form, btn).then(function () { btn.classList.add('is-added'); btn.textContent = 'Added ✓'; setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = '+ Add to bag'; btn.disabled = false; }, 1600); })
        .catch(function (err) { btn.disabled = false; if (err && err.status) showError(btn, err); else form.submit(); });
    }
    if (form.matches('[data-bj10-product-form]')) {
      if (e.submitter && e.submitter.getAttribute('name') !== 'add' && !e.submitter.hasAttribute('data-sticky-btn')) return;
      e.preventDefault();
      var atc = $('[data-atc]', form), label = $('[data-atc-label]', form), fill = $('.atc__fill', form);
      if (!atc || atc.disabled) return;
      atc.disabled = true; label.textContent = 'Adding…';
      if (motion && fill) gsap.fromTo(fill, { scaleX: 0, transformOrigin: 'left' }, { scaleX: 1, duration: .5, ease: 'expo.inOut' });
      addToBag(form, e.submitter && e.submitter.hasAttribute('data-sticky-btn') ? e.submitter : atc).then(function () {
        atc.classList.add('is-added'); label.textContent = 'Added to bag ✓';
        setTimeout(function () { atc.classList.remove('is-added'); label.textContent = 'Add to bag'; atc.disabled = false; if (motion && fill) gsap.to(fill, { scaleX: 0, transformOrigin: 'right', duration: .5, ease: 'expo.inOut' }); }, 1400);
      }).catch(function (err) {
        atc.disabled = false; label.textContent = 'Add to bag'; if (motion && fill) gsap.set(fill, { scaleX: 0 });
        if (err && err.status) showError(atc, err); else form.submit();
      });
    }
  });

  /* ---------------------------------------------------------------- product page */
  var pform = $('[data-bj10-product-form]');
  if (pform) {
    var qv = $('[data-qty-val]', pform), qi = $('[data-qty-input]', pform), q = 1;
    $$('[data-qty]', pform).forEach(function (b) {
      b.addEventListener('click', function () {
        q = Math.max(1, Math.min(20, q + +b.getAttribute('data-qty'))); qv.textContent = q; qi.value = q;
        if (motion) gsap.fromTo(qv, { y: +b.getAttribute('data-qty') * -10, opacity: 0 }, { y: 0, opacity: 1, duration: .35, ease: 'back.out(3)' });
      });
    });
    var sel = $('[data-variant-select]', pform);
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], price = $('[data-current-price]'), atc = $('[data-atc]', pform), lab = $('[data-atc-label]', pform);
      if (price) price.textContent = o.getAttribute('data-price');
      var ok = o.getAttribute('data-available') === 'true'; atc.disabled = !ok; lab.textContent = ok ? 'Add to bag' : 'Sold out';
      var url = new URL(location.href); url.searchParams.set('variant', sel.value); history.replaceState(null, '', url);
    });
    var sticky = $('[data-sticky]'), stickyBtn = $('[data-sticky-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (pform.requestSubmit) pform.requestSubmit(stickyBtn); else pform.submit(); });
    var main = $('.pdp__main');
    if (sticky && main && 'IntersectionObserver' in window) {
      if (motion) gsap.set(sticky, { x: 0, y: 0, xPercent: -50, yPercent: 160 });
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.setAttribute('aria-hidden', String(!show));
        if (motion) gsap.to(sticky, { yPercent: show ? 0 : 160, duration: .7, ease: show ? 'back.out(1.6)' : 'power3.in' });
        else sticky.style.transform = 'translate(-50%,' + (show ? '0' : '160%') + ')';
      }, { rootMargin: '0px 0px -25% 0px' }).observe($('[data-buy]') || main);
    }
    var gal = $('[data-gallery]'), dots = $$('[data-dots] span');
    if (gal && dots.length) gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / ((gal.firstElementChild || gal).offsetWidth + 8));
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
  }
  // accordions (product page)
  $$('.acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentNode, panel = $('.acc__panel', item), open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open));
      if (motion) {
        gsap.fromTo(panel, { height: panel.offsetHeight }, { height: open ? 'auto' : 0, duration: .6, ease: 'expo.inOut', onComplete: function () { ScrollTrigger.refresh(); } });
      } else { panel.style.height = open ? 'auto' : '0'; }
    });
  });

  /* ---------------------------------------------------------------- bag page */
  var cartp = $('[data-cartp]');
  function refreshCartSection() {
    var id = cartp.getAttribute('data-section');
    cartp.classList.add('is-busy');
    return fetch(root + 'cart?section_id=' + id).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = $('[data-cartp]', doc);
      if (fresh) { cartp.innerHTML = fresh.innerHTML; }
      cartp.classList.remove('is-busy');
      return getCart().then(renderBag);
    });
  }
  if (cartp) {
    cartp.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cart-step]'), rm = e.target.closest('[data-cart-remove]');
      var li = e.target.closest('[data-line]'); if (!li || (!step && !rm)) return;
      e.preventDefault();
      var input = $('[data-cart-qty]', li), qty = rm ? 0 : Math.max(0, (+input.value || 0) + +step.getAttribute('data-cart-step'));
      input.value = qty;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +li.getAttribute('data-line'), quantity: qty }) })
        .then(refreshCartSection).catch(function () { $('#Bj10CartForm').submit(); });
    });
  }

  /* ---------------------------------------------------------------- collection page */
  var coll = $('[data-coll]');
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString(); });
  if (coll) {
    var want = new URLSearchParams(location.search).get('c');
    var cfgEl = $('[data-coll-config]'), conf = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    if (want && conf[want] && coll.getAttribute('data-concern') === 'all') {
      var c = conf[want], n = 0;
      $$('.coll__grid .card').forEach(function (card) { var ok = (card.getAttribute('data-tags') || '').split(' ').indexOf(want) > -1; card.hidden = !ok; if (ok) n++; });
      var promo = $('[data-promo]'); if (promo) promo.hidden = true;
      $('[data-coll-hero]').style.background = 'var(--c-' + want + ')';
      $('[data-coll-hand]').textContent = c.hand;
      $('[data-coll-title]').textContent = c.name;
      $('[data-coll-desc]').innerHTML = '<p>' + c.desc + '</p>';
      $('[data-coll-count]').textContent = n;
      $('[data-coll-face-img]').src = c.face;
      var tpl = $('template[data-coll-results]');
      var slot = $('[data-coll-result]');
      if (tpl && slot) { var src = tpl.content.querySelector('[data-result="' + want + '"]'); if (src) { slot.innerHTML = src.innerHTML; slot.classList.remove('is-empty'); } }
      $$('.coll__filters .fpill').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-filter') === want); });
    }
  }

  /* ---------------------------------------------------------------- journal */
  var topic = $('[data-jr-topic]');
  if (topic) topic.addEventListener('change', function () { location.href = topic.value; });

  /* ---------------------------------------------------------------- article */
  var body = $('[data-body]'), toc = $('[data-toc]');
  if (body && toc) {
    var used = {};
    var heads = $$('h2', body).map(function (h) {
      if (!h.id) { var s = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section'; while (used[s]) s += '-2'; h.id = s; }
      used[h.id] = 1; return h;
    });
    if (heads.length > 2) {
      toc.innerHTML = heads.map(function (h) { return '<li><a href="#' + h.id + '" data-toc-link="' + h.id + '">' + h.textContent + '</a></li>'; }).join('');
      toc.closest('nav').hidden = false;
      $$('[data-toc-link]', toc).forEach(function (l) {
        l.addEventListener('click', function (e) { e.preventDefault(); var t = document.getElementById(l.getAttribute('data-toc-link')); if (lenis) lenis.scrollTo(t, { offset: -90, duration: 1.2 }); else t.scrollIntoView({ behavior: 'smooth' }); history.replaceState(null, '', '#' + t.id); });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) $$('[data-toc-link]', toc).forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-toc-link') === en.target.id); }); });
        }, { rootMargin: '0px 0px -60% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }
    $$('table', body).forEach(function (t) { var w = document.createElement('div'); w.className = 'tbl-wrap'; t.parentNode.insertBefore(w, t); w.appendChild(t); });
    var bar = $('[data-progress]');
    if (bar) {
      var upd = function () { var r = body.getBoundingClientRect(), h = r.height - window.innerHeight * .5; bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, (-r.top + window.innerHeight * .3) / Math.max(1, h))) + ')'; };
      window.addEventListener('scroll', upd, { passive: true }); upd();
    }
  }

  /* ---------------------------------------------------------------- before / after */
  function initBA(scope) {
    $$('[data-ba]:not([data-ba-ready])', scope).forEach(function (el) {
      el.setAttribute('data-ba-ready', '');
      var range = $('.ba__range', el);
      var set = function (v) { el.style.setProperty('--pos', v + '%'); range.value = v; };
      set(50);
      range.addEventListener('input', function () { set(+range.value); });
      if (motion && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return; io.disconnect();
          var o = { v: 50 };
          gsap.timeline({ delay: .4 }).to(o, { v: 82, duration: .7, ease: 'power2.inOut', onUpdate: function () { set(o.v); } })
            .to(o, { v: 22, duration: .9, ease: 'power2.inOut', onUpdate: function () { set(o.v); } })
            .to(o, { v: 50, duration: .7, ease: 'power2.out', onUpdate: function () { set(o.v); } });
        }, { threshold: .5 });
        io.observe(el);
      }
    });
  }
  initBA(document);

  /* ---------------------------------------------------------------- ritual toggle */
  var ritual = $('[data-ritual]');
  if (ritual) $$('[data-time]', ritual).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pm = btn.getAttribute('data-time') === 'pm';
      ritual.classList.toggle('is-pm', pm);
      $$('[data-time]', ritual).forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
      $$('.step', ritual).forEach(function (s) { s.classList.toggle('is-off', pm ? !s.hasAttribute('data-pm') : !s.hasAttribute('data-am')); });
    });
  });

  /* ---------------------------------------------------------------- draggable rows */
  function initDrag(scope) {
    $$('[data-drag]:not([data-drag-ready])', scope).forEach(function (vp) {
      vp.setAttribute('data-drag-ready', '');
      var track = $('[data-track]', vp), bar = vp.parentNode.querySelector('[data-progress]');
      var x = 0, target = 0, down = false, startX = 0, startT = 0, moved = 0;
      function max() { return Math.min(0, vp.clientWidth - track.scrollWidth - parseFloat(getComputedStyle(vp).paddingLeft) * 2); }
      function clamp(v) { return Math.max(max(), Math.min(0, v)); }
      vp.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; startX = e.clientX; startT = target; vp.classList.add('is-dragging'); });
      window.addEventListener('pointermove', function (e) { if (!down) return; moved = Math.abs(e.clientX - startX); target = clamp(startT + (e.clientX - startX) * 1.4); });
      window.addEventListener('pointerup', function () { down = false; vp.classList.remove('is-dragging'); });
      vp.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      vp.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); target = clamp(target - e.deltaX); } }, { passive: false });
      if (!fine) { vp.style.overflowX = 'auto'; vp.style.scrollSnapType = 'x mandatory'; return; }
      (function loop() {
        x += (target - x) * 0.09;
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
        var m = max(); if (bar) bar.style.transform = 'scaleX(' + (m ? 0.15 + 0.85 * (x / m) : 1) + ')';
        requestAnimationFrame(loop);
      })();
    });
  }
  initDrag(document);

  /* ---------------------------------------------------------------- recommendations */
  var rel = $('[data-related][data-url]');
  if (rel) {
    var grid = $('[data-related-grid]', rel);
    var load = function (url) { return fetch(url).then(function (r) { return r.text(); }).then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); var g = $('[data-related-grid]', d); return g && g.children.length ? g.innerHTML : ''; }); };
    if (!grid.children.length) rel.style.display = 'none';
    load(rel.getAttribute('data-url')).then(function (h) { return h || load(rel.getAttribute('data-fallback')); }).then(function (h) {
      if (h) { grid.innerHTML = h; rel.style.display = ''; initDrag(rel); if (hasGsap) ScrollTrigger.refresh(); }
      else if (!grid.children.length) rel.style.display = 'none';
    }).catch(function () { if (!grid.children.length) rel.style.display = 'none'; });
  }

  /* ---------------------------------------------------------------- page-leave curtain */
  var curtain = document.createElement('div'); curtain.className = 'curtain'; curtain.setAttribute('aria-hidden', 'true');
  curtain.innerHTML = '<svg class="stamp curtain__stamp" style="color:var(--paper)"><use href="#stamp"/></svg>';
  document.body.appendChild(curtain);
  if (motion) document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || a.hasAttribute('download')) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || u.hash && u.pathname === location.pathname) return;
    if (!/^\/(collections|products|blogs|pages|cart$|search|$)/.test(u.pathname.replace(root, '/'))) return;
    e.preventDefault();
    curtain.style.background = a.getAttribute('data-color') || 'var(--c-brighten)';
    gsap.fromTo(curtain, { clipPath: 'inset(100% 0% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: .5, ease: 'expo.inOut', onComplete: function () { location.href = u.href; } });
    gsap.fromTo($('.stamp', curtain), { scale: 0, rotate: -90 }, { scale: 1, rotate: 0, duration: .5, delay: .1, ease: 'back.out(2)' });
    setTimeout(function () { location.href = u.href; }, 1200);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) curtain.style.clipPath = 'inset(100% 0% 0% 0%)'; });

  /* ================================================================ motion */
  if (!motion) return;
  var fontsReady = Promise.race([document.fonts ? document.fonts.ready : Promise.resolve(), new Promise(function (r) { setTimeout(r, 700); })]);
  fontsReady.then(start);

  function start() {
    /* cursor + magnetic + card hover origin */
    var cursor = $('[data-cursor]');
    if (fine && cursor) {
      var cx = gsap.quickTo(cursor, 'x', { duration: .45, ease: 'power3' }), cy = gsap.quickTo(cursor, 'y', { duration: .45, ease: 'power3' });
      window.addEventListener('pointermove', function (e) { cx(e.clientX); cy(e.clientY); });
      document.addEventListener('pointerover', function (e) {
        var t = e.target.closest('[data-cursor-text]');
        if (t && !t.contains(e.relatedTarget)) { cursor.classList.add('is-big'); $('span', cursor).textContent = t.getAttribute('data-cursor-text'); }
        var m = e.target.closest('.card__media');
        if (m && !m.contains(e.relatedTarget)) { var r = m.getBoundingClientRect(); m.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%'); m.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%'); }
      });
      document.addEventListener('pointerout', function (e) { var t = e.target.closest('[data-cursor-text]'); if (t && !t.contains(e.relatedTarget)) cursor.classList.remove('is-big'); });
      $$('[data-magnetic]').forEach(function (el) {
        var mx = gsap.quickTo(el, 'x', { duration: .6, ease: 'elastic.out(1,0.4)' }), my = gsap.quickTo(el, 'y', { duration: .6, ease: 'elastic.out(1,0.4)' });
        el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); mx((e.clientX - r.left - r.width / 2) * .3); my((e.clientY - r.top - r.height / 2) * .4); });
        el.addEventListener('pointerleave', function () { mx(0); my(0); });
      });
    }

    /* intro: header + page head. Main images are never hidden (keeps LCP fast). */
    var tl = gsap.timeline({ delay: .05 });
    tl.from('.hdr__stamps .stamp, .hdr__logo', { y: -30, opacity: 0, stagger: .05, duration: .7, ease: 'back.out(2)' }, 0)
      .from('.hdr__nav .pill, .hdr__actions > *', { y: -40, opacity: 0, stagger: .04, duration: .8, ease: 'back.out(1.8)' }, .05);
    if (hero) {
      tl.from('[data-hero-media] img, [data-hero-product] img', { scale: 1.15, duration: 1.8, ease: 'expo.out' }, 0)
        .from(splitLines($('.hero__title')), { yPercent: 110, duration: 1, stagger: .08, ease: 'expo.out' }, .1)
        .from('[data-hero-hand]', { opacity: 0, y: 20, rotate: -8, duration: .8, ease: 'back.out(2)' }, .2)
        .from('[data-hero-sub]', { opacity: 0, y: 16, stagger: .08, duration: .7, ease: 'power3.out' }, .3)
        .from('.hero__stamp', { scale: 0, rotate: -180, duration: 1.1, ease: 'back.out(1.6)' }, .3);
    }
    var ct = $('[data-coll-title]');
    if (ct) tl.from(splitLines(ct), { yPercent: 110, duration: 1, stagger: .07, ease: 'expo.out' }, .1)
      .from('[data-coll-hand]', { opacity: 0, y: 18, rotate: -10, duration: .8, ease: 'back.out(2)' }, .2)
      .from('[data-coll-face-img]', { scale: 1.2, duration: 1.6, ease: 'expo.out' }, 0)
      .from('[data-coll-result]:not(.is-empty)', { y: 70, opacity: 0, rotate: 8, duration: .9, ease: 'back.out(1.6)' }, .5)
      .from('.coll__stamp', { scale: 0, rotate: -160, duration: 1.1, ease: 'back.out(1.6)' }, .3)
      .from('.coll__filters .fpill, .coll__sort', { y: 24, opacity: 0, stagger: .04, duration: .6, ease: 'back.out(2)' }, .4)
      .from('.coll__grid > *:nth-child(-n+8)', { y: 90, opacity: 0, rotate: function (i) { return i % 2 ? 3 : -3; }, stagger: .05, duration: 1.1, ease: 'expo.out' }, .45);
    var pt = $('[data-pdp] [data-title]');
    if (pt) tl.from('.pdp__shot:first-child img', { scale: 1.15, duration: 1.6, ease: 'expo.out' }, 0)
      .from('[data-concern]', { scale: 0, rotate: -12, duration: .6, ease: 'back.out(2.4)' }, .1)
      .from('[data-hand]', { opacity: 0, y: 16, rotate: -10, duration: .7, ease: 'back.out(2)' }, .15)
      .from(splitLines(pt), { yPercent: 110, duration: 1, stagger: .07, ease: 'expo.out' }, .12)
      .from('[data-price], [data-intro], .pdp__rating', { opacity: 0, y: 16, stagger: .06, duration: .7, ease: 'power3.out' }, .3)
      .from('.pdp__form > *, .chips li, .acc__item', { opacity: 0, y: 20, stagger: .04, duration: .6, ease: 'power3.out' }, .4);
    var at = $('[data-art] [data-title]');
    if (at) tl.from(splitLines(at), { yPercent: 110, duration: 1.1, stagger: .07, ease: 'expo.out' }, .1)
      .from('[data-cat-pill]', { scale: 0, rotate: -12, duration: .6, ease: 'back.out(2.4)' }, .15)
      .from('[data-lead], [data-meta], .art__share', { opacity: 0, y: 16, stagger: .06, duration: .7, ease: 'power3.out' }, .35)
      .from('[data-hero-img] img', { scale: 1.2, duration: 1.8, ease: 'expo.out' }, 0);
    var jt = $('[data-jr-title]');
    if (jt) tl.from(splitLines(jt), { yPercent: 110, duration: 1.1, stagger: .07, ease: 'expo.out' }, .1)
      .from('[data-jr-hand]', { opacity: 0, y: 18, rotate: -10, duration: .8, ease: 'back.out(2)' }, .2)
      .from('[data-jr-desc], [data-jr-count]', { opacity: 0, y: 16, stagger: .06, duration: .7, ease: 'power3.out' }, .3)
      .from('.jr__stamp', { scale: 0, rotate: -160, duration: 1.1, ease: 'back.out(1.6)' }, .3)
      .from('.jr__feature-copy > *', { opacity: 0, y: 20, stagger: .06, duration: .7, ease: 'power3.out' }, .4);

    /* hero parallax */
    if (hero) {
      gsap.to('[data-hero-media]', { yPercent: 18, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('[data-hero-product]', { yPercent: 30, scale: 1.1, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('.hero__copy', { yPercent: -50, opacity: 0, ease: 'none', scrollTrigger: { trigger: hero, start: '35% top', end: 'bottom top', scrub: true } });
    }

    /* stamps + marquee speed up with scroll velocity */
    var marquee = $('[data-marquee]');
    if (marquee) marquee.innerHTML += marquee.innerHTML;
    var spin = gsap.to($$('[data-spin], .hdr__stamps .stamp, .marquee__track .stamp'), { rotate: 360, duration: 14, ease: 'none', repeat: -1 });
    var mq = marquee ? gsap.to(marquee, { xPercent: -50, duration: 26, ease: 'none', repeat: -1 }) : null;
    var vel = 0, ts = 1, skew = 0, setSkew = marquee ? gsap.quickSetter(marquee, 'skewX', 'deg') : function () {};
    ScrollTrigger.create({ start: 0, end: 'max', onUpdate: function (self) { vel = self.getVelocity(); } });
    gsap.ticker.add(function () {
      ts += ((1 + Math.min(Math.abs(vel) / 250, 7)) - ts) * 0.1; skew += (gsap.utils.clamp(-9, 9, -vel / 300) - skew) * 0.12; vel *= 0.9;
      spin.timeScale(ts); if (mq) mq.timeScale(ts); setSkew(skew);
    });

    /* generic reveals */
    $$('[data-split]').forEach(function (el) { var l = splitLines(el); if (l.length) gsap.from(l, { yPercent: 110, duration: 1.1, stagger: .09, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 88%' } }); });
    $$('[data-fade]').forEach(function (el) { gsap.from(el, { y: 30, opacity: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 90%' } }); });
    $$('.hand').forEach(function (el) {
      if (el.closest('.hero, .card, .ftr, [data-lineup], [data-no-hand-reveal], .bag, .menu, .coll__result')) return;
      gsap.from(el, { opacity: 0, y: 20, rotate: -10, duration: .8, ease: 'back.out(2.2)', scrollTrigger: { trigger: el, start: 'top 92%' } });
    });
    $$('[data-parallax]').forEach(function (el) {
      gsap.fromTo($('img', el), { yPercent: 0 }, { yPercent: parseFloat(el.getAttribute('data-parallax')), ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$('[data-count]').forEach(function (el) {
      var o = { v: 0 }, end = +el.getAttribute('data-count'); if (!end) return;
      gsap.to(o, { v: end, duration: 1.6, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 92%' }, onUpdate: function () { el.textContent = Math.round(o.v); } });
    });
    $$('[data-cards], [data-guides], .jr__grid').forEach(function (row) {
      var cards = $$('.card, .acard, .jr__cta', row); if (!cards.length) return;
      gsap.set(cards, { y: 90, opacity: 0 });
      ScrollTrigger.batch(cards, { start: 'top 96%', onEnter: function (b) { gsap.to(b, { y: 0, opacity: 1, stagger: .07, duration: 1.1, ease: 'expo.out', overwrite: true }); } });
    });
    $$('[data-rise]').forEach(function (g) { gsap.from(g.children, { y: 80, opacity: 0, rotate: function (i) { return i % 2 ? 3 : -3; }, stagger: .08, duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: g, start: 'top 88%' } }); });
    if ($('[data-shelf]')) gsap.from('.shelf__head > *', { y: 30, opacity: 0, stagger: .1, duration: .9, ease: 'power3.out', scrollTrigger: { trigger: '[data-shelf]', start: 'top 85%' } });
    if ($('[data-lineup]')) {
      var mm = gsap.matchMedia();
      mm.add('(min-width: 750px)', function () {
        gsap.timeline({ scrollTrigger: { trigger: '[data-lineup]', start: 'top top', end: '+=150%', scrub: 1, pin: true } })
          .from('[data-lineup-title]', { scale: 1.5, opacity: 0, duration: 1, ease: 'power2.out' })
          .from('[data-lineup-hand]', { opacity: 0, rotate: -14, y: 30, duration: .5 }, .3)
          .from('.lineup__item', { yPercent: 140, rotate: function (i) { return (i - 2.5) * 6; }, stagger: .18, duration: 1, ease: 'power3.out' }, .4)
          .from('.lineup__stamp', { scale: 0, duration: .6, stagger: .3, ease: 'back.out(2)' }, 1.2);
      });
      mm.add('(max-width: 749px)', function () { gsap.from('.lineup__item', { y: 70, opacity: 0, stagger: .08, duration: 1, ease: 'expo.out', scrollTrigger: { trigger: '[data-lineup]', start: 'top 75%' } }); });
    }
    var scrub = $('[data-scrub-words]');
    if (scrub) gsap.to(splitWords(scrub), { opacity: 1, stagger: .05, ease: 'none', scrollTrigger: { trigger: scrub, start: 'top 78%', end: 'bottom 55%', scrub: true } });
    if ($('[data-steps]')) gsap.from('.step', { y: 70, opacity: 0, rotate: function (i) { return (i - 1) * 5; }, stagger: .1, duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: '[data-steps]', start: 'top 85%' } });
    if ($('.tiles')) gsap.from('.tile', { y: 120, rotate: function (i) { return i % 2 ? 5 : -5; }, opacity: 0, stagger: .09, duration: 1.3, ease: 'expo.out', scrollTrigger: { trigger: '.tiles', start: 'top 88%' } });
    if ($('[data-stars]')) gsap.from('[data-stars] svg', { scale: 0, rotate: -90, stagger: .08, duration: .7, ease: 'back.out(3)', scrollTrigger: { trigger: '[data-stars]', start: 'top 88%' } });
    // product gallery: later shots reveal and drift (desktop)
    gsap.matchMedia().add('(min-width: 901px)', function () {
      $$('.pdp__shot').slice(1).forEach(function (fig) {
        gsap.fromTo(fig, { clipPath: 'inset(8% 8% 8% 8% round 6px)' }, { clipPath: 'inset(0% 0% 0% 0% round 6px)', duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: fig, start: 'top 88%' } });
      });
    });
    if ($('.pdp__ingr-stamp')) gsap.fromTo('.pdp__ingr-stamp', { scale: .6 }, { scale: 1.2, ease: 'none', scrollTrigger: { trigger: '.pdp__ingr', start: 'top bottom', end: 'bottom top', scrub: true } });
    $$('.prose h2').forEach(function (el) { gsap.from(el, { y: 26, opacity: 0, duration: .8, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 90%' } }); });
    $$('.prose figure').forEach(function (el) { gsap.fromTo(el, { clipPath: 'inset(8% 8% 8% 8% round 8px)' }, { clipPath: 'inset(0% 0% 0% 0% round 8px)', duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 88%' } }); });
    if ($('.art__cta')) gsap.from('.art__cta', { y: 60, opacity: 0, duration: 1, ease: 'expo.out', scrollTrigger: { trigger: '.art__cta', start: 'top 92%' } });

    /* footer wordmark rises as the page lifts away */
    var ftr = $('[data-ftr]'), mainEl = $('#MainContent');
    if (ftr && mainEl) gsap.from('[data-word] span', { yPercent: 100, stagger: .05, ease: 'none', scrollTrigger: { trigger: mainEl, start: 'bottom bottom', end: function () { return 'bottom ' + Math.max(0, window.innerHeight - ftr.offsetHeight * .9) + 'px'; }, scrub: true, invalidateOnRefresh: true } });

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }
})();
